export default __webpack_public_path__ + "static/media/Wall_Door_Center_Grey.256.6e3db103.png";